import { createSelector } from "reselect";
import { RootState } from "common/reducers";

export const loadingCounter = (state: RootState): number => {
  return state.getIn(["ui", "loadingCounter"]);
};
export const isLoading = createSelector([loadingCounter], (loadingCounter) => loadingCounter > 0);
